import ScrollReveal from '@/components/common/ScrollReveal';
import GradientIcon from '@/components/common/GradientIcon';
import { suite } from '@/mocks/landing';
import SectionTitle from './SectionTitle';

export default function ProductSuite() {
  return (
    <section id="products" className="w-full bg-white pb-16 md:pb-24">
      <SectionTitle title="One platform for earning, redeeming and growing" />

      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="rounded-[28px] bg-gradient-to-b from-[#a9c7ff] via-[#c5d8ff] to-[#e3ecff] px-4 py-10 md:px-16 md:py-14">
          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
            {suite.map((group, gi) => (
              <ScrollReveal
                key={group.label}
                animation="fade-up"
                delay={gi * 80}
                className={`rounded-2xl bg-white/95 p-5 md:p-6 ${group.wide ? 'md:col-span-2' : ''}`}
              >
                <div className="flex items-center justify-center gap-2 text-sm font-semibold text-[#1f2329]">
                  <span className="rounded-md bg-[#1f2329] text-white text-[10px] px-1.5 py-0.5">{group.label}</span>
                  {group.title}
                </div>
                <div className={`mt-6 grid gap-y-6 gap-x-2 ${group.wide ? 'grid-cols-3 sm:grid-cols-4 md:grid-cols-7' : 'grid-cols-3'}`}>
                  {group.items.map((item) => (
                    <a key={item.name} href="#pricing" className="group flex flex-col items-center text-center">
                      <span className="w-12 h-12 rounded-2xl flex items-center justify-center group-hover:-translate-y-1 group-hover:bg-[#f5f7ff] transition-all">
                        <GradientIcon icon={item.icon} tone={item.tone} size="text-[32px]" />
                      </span>
                      <span className="mt-1.5 text-xs font-semibold text-[#1f2329]">{item.name}</span>
                      <span className="text-[10px] text-[#8f959e]">{item.text}</span>
                    </a>
                  ))}
                </div>
              </ScrollReveal>
            ))}
          </div>

          <div className="mt-8 flex justify-center">
            <a
              href="#contact"
              className="inline-flex items-center h-9 px-5 rounded-full border border-[#1f2329]/20 bg-white/70 text-xs font-semibold text-[#1f2329] hover:bg-white transition-colors"
            >
              Talk to us to learn more
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
